import {DjPsycho} from "../DjPsycho";
import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TimelineLite} from "gsap";
import {DjPsychoSymbol, DjPsychoSymbolStates} from "../reels/DjPsychoSymbol";
import {SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";

export class DjPsychoWinCapHitRunner implements ISimplePresentation {

    private _controller: ISimplePresentationRunnerController;

    public shouldRun(): boolean {
        return DjPsycho.model.gameData.brokeBank;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        this._controller = controller;
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            DjPsycho.winCapView.show(() => {
                DjPsycho.reelView.reelModels.forEach((reel: SimpleReelModel) => {
                    reel.symbols.forEach((symbol: DjPsychoSymbol) => {
                        symbol.setState(DjPsychoSymbolStates.NORMAL);
                    });
                });
                this.readyToSkip();
                DjPsycho.keypadPlugin.setWin(DjPsycho.model.gameData.accumulatedRoundWin, true);
            }),
            () => {
                DjPsycho.keypadPlugin.setZeroBetSpinCounter(-1);

                // #98
                DjPsycho.hotZone.hideHotZone();
            }
        ]);
    };

    private readyToSkip(): void {
        this._controller.setSkipCallback(() => this.skip());
    }

    private skip(): void {
        const tl: TimelineLite = new TimelineLite();

        this._controller.setSkipCallback();

        tl.add(DjPsycho.winCapView.onButtonClick());
        tl.add(() => {
            this._controller.finish();
            DjPsycho.buyFeatureName = "";

            DjPsycho.popUpView.showPopUp();
        });

        // #50
        DjPsycho.soundPlayer.switchMusic(DjPsycho.model.gameData.nextMode);
    }
}
